import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.offWhite,
  h1Color: colors.charcoalGrey,
  h2Color: colors.charcoalGrey,
  paraColor: colors.charcoalGrey,
  anchorColor: colors.dustyTeal
};
export default richText;